import { render } from "./file_preview_dialog.vue?vue&type=template&id=09cf7bbb&ts=true"
import script from "./file_preview_dialog.vue?vue&type=script&lang=ts"
export * from "./file_preview_dialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__